import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form, Formik } from 'formik';
import { Box, Grid } from '@mui/material';
import * as Yup from 'yup';

import useNotification from '../../../../../core/hooks/use_notification';
import TextFieldFormik from '../../../../common/text_field';
import { getCouponTranslationState } from '../../../../../features/coupon/get_coupon_translation';
import { SubmitButton } from '../../../../common/button';
import { updateCouponTranslationAction, updateCouponTranslationState } from '../../../../../features/coupon/update_coupon_translation';
import { updateCouponTranslationNotificationData } from '../../../../../core/utils/notification_utils';
import SectionPaper from '../../../../common/section_paper';
import BottomActionBar from '../../../../common/bottom_action_bar';

const CouponTranslationForm = ({ disableForm, couponId, languageCode }) => {
    const dispatch = useDispatch();
    const { showNotification } = useNotification();

    const getCouponTranslation = useSelector(getCouponTranslationState);
    const updateCouponTranslation = useSelector(updateCouponTranslationState);

    const initialValues = {
        name: getCouponTranslation?.data?.name || '',
        description: getCouponTranslation?.data?.description || ''
    };

    const schema = Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required()
    });

    const onSubmit = (values) => {
        if (disableForm) return;

        const form = {
            ...values,
            languageCode
        };

        dispatch(updateCouponTranslationAction({ form, couponId }))
            .then(response => showNotification((updateCouponTranslationNotificationData(response))));
    };

    return (
        <Formik
            initialValues={ initialValues }
            validationSchema={ schema }
            validateOnChange={ false }
            validateOnBlur={ false }
            onSubmit={ onSubmit }>
            { () => (
                <Box component={ Form } sx={ { display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1 } }>
                    <Box sx={ { flexGrow: 1, pb: 4 } }>
                        <SectionPaper title="Treść dla klienta">
                            <Grid container spacing={ 3 }>
                                <Grid item xs={ 12 } md={ 8 } lg={ 6 }>
                                    <TextFieldFormik name="name" label="Nazwa wyśtwietlana dla klienta" required
                                                     disabled={ disableForm }/>
                                </Grid>
                                <Grid item xs={ 12 }>
                                    <TextFieldFormik name="description" label="Szczegółowy opis" multiline rows={ 4 }
                                                     required disabled={ disableForm }/>
                                </Grid>
                            </Grid>
                        </SectionPaper>
                    </Box>

                    {
                        !disableForm &&
                        <BottomActionBar>
                            <Box sx={ { display: 'flex', justifyContent: 'flex-end', width: '100%' } }>
                                <SubmitButton isLoading={ updateCouponTranslation?.loading }>Zapisz
                                    tłumaczenie</SubmitButton>
                            </Box>
                        </BottomActionBar>
                    }
                </Box>
            ) }
        </Formik>
    );
};

export default CouponTranslationForm;